import type { roles as en } from '@/i18n/locales/en/roles';
import type { Translation } from '@/i18n/types';

export const roles: Translation<typeof en> = {
  form: {
    person: 'Kişi',
    choose: 'Seçin…',
    grant: '{{label}} ver',
    revoke: '{{label}} iptal et',
    back: 'Geri',
  },
  company: {
    title: 'Şirket yöneticileri',
    lead: 'Bir şirket yöneticisi, şirketin kendi bilgilerini, departmanlarını, üyelerini ve kayıt işlemlerini yönetir. Verme ve iptal etme denetlenir.',
    label: 'şirket yöneticisi',
    rowsLabel: 'şirket üyeleri',
  },
  department: {
    title: 'Departman yöneticileri (koç)',
    lead: 'Bir departman yöneticisi bu departmanın üyelerini ve toplu verilerini ve bireysel erişim kuralı uyarınca, rıza dayanağının kapsadığı bireysel istatistikleri okuyabilir. Verme ve iptal etme denetlenir.',
    label: 'departman yöneticisi',
    rowsLabel: 'departman üyeleri',
  },
  admins: {
    title: 'Platform yöneticileri',
    lead: 'Bir platform yöneticisi her kapsamda tüm yetkiye sahiptir. Bir atamanın hedefi kendi girişine sahip olmalı ve birincil bir kimlik olmalıdır; son yönetici görevden alınamaz.',
    name: 'Ad',
    email: 'E-posta',
    retire: 'Görevden al',
    rowsLabel: 'yöneticiler',
    searchPeople: 'Kişi ara',
    searchPlaceholder: 'Ad veya e-posta',
    person: 'Kişi',
    choose: 'Seçin…',
    noEligible: 'Uygun kişi bulunamadı — kendi girişlerinin olması gerekir.',
    appoint: 'Ata',
    usersLabel: 'platformun kullanıcıları',
  },
};
